import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Apollo, gql } from 'apollo-angular';

import { VMContentQuery, VMContentTipsQuery, VMContentItem} from '../../vm_models';
import { VMContentMapper} from '../../vm_mappers';

@Injectable()
export class GraphQLVMService {
    constructor(
        private apollo: Apollo
    ) { }

    getContentItems(path: string): Observable<Array<VMContentItem>> {
        var variables = {};
        if (path) {
          variables["path"] = path;
        };
        
        return this.apollo.query<VMContentQuery>({
            query: gql`fragment ContentItemFragment on VeiligheidsmeterContentItem {
              id
              path
              template {
                name
                __typename
              }
              title {
                value
                __typename
              }
              content {
                value
                __typename
              }
              __typename
            }
            
            fragment ContentItemsFragment on VeiligheidsmeterContentItems {
              id
              path
              template {
                name
                __typename
              }
              __typename
              children {
                ... on VeiligheidsmeterContentItem {
                  ...ContentItemFragment
                }
              }
            }
            
            query VeiligheidsmeterContentItems($path: String) {
              contentItems: item(path: $path) {
                ... on VeiligheidsmeterContentItems {
                  id
                  path
                  template {
                    name
                    __typename
                  }
                  __typename
                  children {
                    ... on VeiligheidsmeterContentItem {
                      ...ContentItemFragment
                    }
                    ... on VeiligheidsmeterContentItems {
                      ...ContentItemsFragment
                      children {
                        ... on VeiligheidsmeterContentItems {
                          ...ContentItemsFragment
                        }
                      }
                    }
                  }
                }
              }
            }`, variables: variables
        }).pipe(
            map(response => {
                return response.data.contentItems;
            }),
            map(contentItems => VMContentMapper.calculateVMContentItems(contentItems.children))
        );
    }

    getContentItemsTips(path: string): Observable<Array<VMContentItem>> {
      var variables = {};
      if (path) {
        variables["path"] = path;
      };

      return this.apollo.query<VMContentTipsQuery>({
          query: gql`fragment TipFragment on VeiligheidsmeterTip {
            id
            path
            template {
              name
              __typename
            }
            title {
              value
              __typename
            }
            content {
              value
              __typename
            }
            titleShort {
              value
              __typename
            }
            contentShort {
              value
              __typename
            }
            __typename
          }
          
          fragment TipsFragment on VeiligheidsmeterTips {
            id
            path
            template {
              name
              __typename
            }
            __typename
            children {
              ... on VeiligheidsmeterTip {
                ...TipFragment
              }
            }
          }
          
          query VeiligheidsmeterTips($path: String) {
            tips: item(path: $path) {
              ... on VeiligheidsmeterTips {
                id
                path
                template {
                  name
                  __typename
                }
                __typename
                children {
                  ... on VeiligheidsmeterTip {
                    ...TipFragment
                  }
                  ... on VeiligheidsmeterTips {
                    ...TipsFragment
                    children {
                      ... on VeiligheidsmeterTips {
                        ...TipsFragment
                      }
                    }
                  }
                }
              }
            }
          }
          `, variables: variables
      }).pipe(
          map(response => {
              return response.data.tips;
          }),
          map(tips => VMContentMapper.calculateVMContentItemsTips(tips))
      );
  }
}
